import { TransactionStatus } from '@app/wallet/models/transaction.model';

export interface CryptoInfo {
  supportedNetworks: Map<string, string[]>;
  rates: Map<string, number>;
}

export interface CryptoPaymentStatus {
  status: TransactionStatus;
  transactionId?: number;
}

export enum CryptoCoinLabel {
  BIT = 'BTC',
  ETH = 'ETH',
  SOL = 'SOL',
  BNB = 'BNB',
  DOGE = 'DOGE',
  USDC = 'USDC',
  USDT = 'USDT',
}

export enum CryptoNetworkLabel {
  BSC = 'Binance Smart Chain',
  ETH = 'Ethereum',
  SOL = 'Solana',
}

export enum SpecificCoinLabel {
  btc = 'btc',
  eth = 'eth',
  sol = 'sol',
  bnbbsc = 'bnbbsc',
  doge = 'doge',
  usdc = 'usdc',
  usdcbsc = 'usdcbsc',
  usdcsol = 'usdcsol',
  usdterc20 = 'usdterc20',
  usdtbsc = 'usdtbsc',
  usdtsol = 'usdtsol',
}

export enum CryptoNetwork {
  BSC,
  ETH,
  SOL,
  DOGE,
  BTC,
}
